export default __webpack_public_path__ + "static/media/landing.bd2a9c17.png";